import type { ComponentProps, ReactNode } from "react";
import { cn } from "../../lib/utils.js";

/**
 * Layout-only table chrome. Callers own data, selection, and pagination.
 * Header stickiness is `tableWorkspaceHeadRowClass` on the `<tr>`.
 */
export function TableWorkspace({
  children,
  className,
  ...rest
}: {
  children: ReactNode;
  className?: string;
} & Omit<ComponentProps<"div">, "children" | "className">): React.JSX.Element {
  return (
    <div className={cn("flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden", className)} {...rest}>
      {children}
    </div>
  );
}

export function TableWorkspaceScroll({
  children,
  className,
  ...rest
}: {
  children: ReactNode;
  className?: string;
} & Omit<ComponentProps<"div">, "children" | "className">): React.JSX.Element {
  return (
    <div
      className={cn(
        "min-h-0 flex-1 overflow-auto overscroll-contain [scrollbar-gutter:stable]",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function TableWorkspaceFooter({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        "flex shrink-0 flex-wrap items-center justify-between gap-2 border-t border-border/60 bg-surface px-3 py-2",
        className,
      )}
    >
      {children}
    </div>
  );
}

export const tableWorkspaceHeadRowClass = "sticky top-0 z-[1]";
